import React from 'react';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
//import axios from 'axios';
import api from './../../../services/api';
import axios from 'axios';
import { login } from '../../../services/Auth'
import { withRouter } from 'react-router-dom';
import { Spinner } from 'react-activity';
import 'react-activity/dist/react-activity.css'
import Collapse from 'react-collapse';
import { NavLink } from 'react-router-dom';

//import da API
import { authenticate } from './../../../services/api';
let apiAuthenticate = new authenticate();
class Forms_RI_Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            id: "",
            loading: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }
    handleSubmit = evt => {
        evt.preventDefault();
        this.setState({loading: true})
        const agent = {
            email: this.state.email,
            password: this.state.password,
        };

        if (!agent.email || !agent.password) {
            this.setState({ error: "Preencha e-mail e senha para continuar!" });
            console.log('Preencha e-mail e senha para continuar!')
        } else {
            //axios.post(`https://convida-api-backup.herokuapp.com/authenticate/agent`, agent)
            apiAuthenticate.AgentLogin(agent)    
            //apiAuthenticate.AgentLogin(agent)
            .then(res => {
                console.log(res);
                console.log(res.data);
                console.log(agent);
                login(res.data.token, res.data._id);
                this.setState({
                    id: res.data._id,
                    loading: false
                })
                console.log("id nova", this.state.id)
                localStorage.setItem("id_agent", this.state.id);
                this.props.history.push("/RI_Painel");
            }).catch(error => {
                this.setState({loading: false})
                alert("E-mail ou Senha incorretos!")})
        }
    }
    render() {

        return (
            <>
                <form onSubmit={this.handleSubmit} id="forms-PS-Login">
                    <input onChange={this.handleChange} name="email" placeholder="E-mail" id="RI-Login-Main" required/>
                    <input onChange={this.handleChange} name="password" type="password" placeholder="Senha" id="RI-Login-Main" required/>
                    <button onClick={() => this.handleSubmit} id="RI-Cadastro">
                        <Collapse isOpened={this.state.loading}>
                        <Spinner color="#FFFFFF" />
                        </Collapse>
                        <p>Fazer Login</p>
                    </button>
                    <NavLink to="/Tela_RedefinirSenha_RI" className="navlink-padrao-style"><p className="btn-fp-main">Esqueci a Senha</p></NavLink>
                </form>
            </>
        );
    }
}
Forms_RI_Login = withRouter(Forms_RI_Login);
export default Forms_RI_Login;

